<template>
  <v-container class="menu-opt">
    <template>
      <div class="row">
          <div class="columnStyle">
            <button
              v-on:click="InitialifoPage()"
              style="height: 50% !important ; width: 0%">
              <img
                :src=acctOpnIcon alt="Account Opening" width="100px"/><br />
              <b style="font-size: 20px">Account Opening</b>
            </button>
          </div>
          <div class="columnStyle" style="display: none;">
            <button
              v-on:click="InitialifoPage()"
              style="height: 50% !important ; width: 0%"
            >
              <img
                src="@/assets/images/KYCUpdate1.svg"
                alt="Account Opening"
                width="100px"
              /><br />
              <b style="font-size: 20px">KYC Update</b>
            </button>
          </div>
          <div class="columnStyle" style="display: none;">
            <button
              v-on:click="InitialifoPage()"
              style="height: 50% !important ; width: 0%"
            >
              <img
                src="@/assets/images/DSACommissionAnalytics1.svg"
                alt="Account Opening"
                width="100px"
              /><br />
              <b style="font-size: 20px">DSA Commission Analytics</b>
            </button>
          </div>
        </div>


    </template>

    <!-- <template>
     <div class="row">
        <div class="col-lg-6">
            <v-btn v-on:click="InitialifoPage()" style="height:50% !important ;width: 0%;">
                <img src="./pwa/images/AccountOpeningLogo.svg" alt="Account Opening"/><br>

            </v-btn>
            <div>Account Opening</div>
        </div>
        <div class="col-lg-6">
            <v-btn v-on:click="InitialifoPage()" style="height:50% !important ;width: 0%;">
                <img src="./pwa/images/AccountOpeningLogo.svg" alt="Account Opening"/><br>

            </v-btn>
            <div>KYC Update</div>
        </div>
        <div class="col-md-4">
            <v-btn v-on:click="InitialifoPage()" style="height:50% !important ;width: 0%;">
                <img src="./pwa/images/AccountOpeningLogo.svg" alt="Account Opening"/><br>

            </v-btn>
            <div>Customer Search</div>
        </div>

        </div>

        <v-flex col-md-4>
            <v-btn v-on:click="InitialifoPage()" style="height:50% !important ;width: 0%;">
                <img src="./pwa/images/AccountOpeningLogo.svg" alt="Account Opening"/><br>

            </v-btn>
            <div>Edit Customer Details</div>
        </v-flex>
        <v-flex col-md-4>
            <v-btn v-on:click="InitialifoPage()" style="height:50% !important ;width: 0%;">
                <img src="./pwa/images/AccountOpeningLogo.svg" alt="Account Opening"/><br>

            </v-btn>
            <div>DSA Commission Analytics</div>
        </v-flex>
        <v-flex col-md-4>
            <v-btn v-on:click="InitialifoPage()" style="height:50% !important ;width: 0%;">
                <img src="./pwa/images/AccountOpeningLogo.svg" alt="Account Opening"/><br>

            </v-btn>
            <div>Manage Profile</div>
        </v-flex>
        </template> -->

        <!--Preloader starts-->
<div class="pre-loader" v-show="PreLoader==true" v-hide="PreLoader == false">
    
    <img :src="preLoaderImg">
  
  </div>
  
  <!--Preloader ends-->
  </v-container>
</template>

<script type="text/javascript">
import router from '@/router';
import acctOpeningIcon from '@/assets/images/AccountOpening.png';
import loader from '@/assets/images/Preloader.gif';
// import { db } from '@/sunidhiapp';
// import axios from 'axios';


export default {
  name: 'menuSelection',
  data: function () {
    return {
      acctOpnIcon: acctOpeningIcon,
      preLoaderImg: loader,
      PreLoader: false
    };
  },
  mounted: async function () {
    this.$sunidhi.logoutBtnDisp = true;
  },
  methods: {
    async InitialifoPage() {
      
      this.$sunidhi.logoutBtnDisp = true;
      router.push({ name: "initial_info" });
      // router.push({ name: "CommissionPage" });
    },
  },
};
</script>

<style lang="css" scoped>



.login-left-img {
  width: 400px;
  border-radius: 15px;
}
.btnStyle {
  width: 0%;
  /* height: 50%; */
}
.columnStyle {
  float: left;
  width: 33.3%;
  padding: 10px;
  height: 300px;
  padding-left: 10%;
}

/* Clear floats after the columns */
.rowStyle:after {
  content: "";
  display: table;
  clear: both;
}

.menu-opt { 
  background-color: white;
  position: relative;
}

@media screen and (max-width:1400px) {
  .menu-opt {
    
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
  }

}

/* .LogoutStyle{
  display: block !important;
} */

</style>


